/**
 * List of supported languages
 */
export const LANG_EN = "en";

/**
 * The site language based on the hostname
 */
export const SITE_LANGUAGE = LANG_EN;
